import { useCallback, useState } from "react";
import {
    getUnits,
    getProcedureMasters,
    getUsersByRole,
    getAppointmentDetailsById,
    getAppointmentsByPatientId,
    getAppointmentfiles,
    getDoctorSlots,
    getDoctorSlotsForDate,
    getDashboardSummary,
} from "../../Services/masterService";

export const useMasterData = () => {
    const [units, setUnits] = useState([]);
    const [procedures, setProcedures] = useState([]);
    const [usersByRole, setUsersByRole] = useState([]);
    const [appointmentDetails, setAppointmentDetails] = useState([]);
    const [appointmentsByPatientId, setAppointmentsByPatientId] = useState([]);
    const [appointmentFiles, setAppointmentFiles] = useState([]);
    const [doctorSlots, setDoctorSlots] = useState([]);
    const [doctorSlotsByDate, setDoctorSlotsByDate] = useState([]);
    const [doctorDashboardCounts, setDoctorDashboardCounts] = useState([]);
    const [masterLoading, setMasterLoading] = useState(false);

    const normalizeData = (response) => {
        if (response?.success) {
            return response?.data || [];
        }

        console.error(response?.message || "Failed to fetch master data");
        return [];
    };

    const fetchUnits = useCallback(async (orgId) => {
        try {
            setMasterLoading(true);
            const response = await getUnits(orgId);
            const data = normalizeData(response);
            setUnits(data);
            return data;
        } catch (error) {
            console.error("Get units failed:", error);
            return [];
        } finally {
            setMasterLoading(false);
        }
    }, []);

    const fecthAppointmentfiles = useCallback(async (appointmentId) => {
        try {
            setMasterLoading(true);
            const response = await getAppointmentfiles(appointmentId);
            const data = normalizeData(response);
            setAppointmentFiles(data);
            return data;
        } catch (error) {
            console.error("Get units failed:", error);
            return [];
        } finally {
            setMasterLoading(false);
        }
    }, []);

    const fetchProcedureMasters = useCallback(async (orgId, unitId) => {
        try {
            setMasterLoading(true);
            const response = await getProcedureMasters(orgId, unitId);
            const data = normalizeData(response);
            setProcedures(data);
            return data;
        } catch (error) {
            console.error("Get procedure masters failed:", error);
            return [];
        } finally {
            setMasterLoading(false);
        }
    }, []);

    const fetchUsersByRole = useCallback(async (orgId, roleId) => {
        try {
            setMasterLoading(true);
            const response = await getUsersByRole(orgId, roleId);
            const data = normalizeData(response);
            setUsersByRole(data);
            return data;
        } catch (error) {
            console.error("Get users by role failed:", error);
            return [];
        } finally {
            setMasterLoading(false);
        }
    }, []);
    
    const fetchAppointmentDetailsById = useCallback(async (orgId, appointmentId) => {
        try {
          setMasterLoading(true);
      
          const response = await getAppointmentDetailsById(orgId, appointmentId);
      
          const data = response?.appointment || response?.data?.[0] || response?.data || null;
      
          setAppointmentDetails(data);
          return data;
        } catch (error) {
          console.error("Get appointment details failed:", error);
          return null;
        } finally {
          setMasterLoading(false);
        }
      }, []);
    
    const fetchAppointmentByPatientId = useCallback(async (orgId, patientId) => {
        try {
            setMasterLoading(true);
            const response = await getAppointmentsByPatientId(orgId, patientId);
            const data = normalizeData(response);
            setAppointmentsByPatientId(data || null);
            return data || null;
        } catch (error) {
            console.error("Get appointment details failed:", error);
            return null;
        } finally {
            setMasterLoading(false);
        }
    }, []);

    const fetchDoctorSlots = useCallback(async (orgId, doctorId) => {
        try {
            setMasterLoading(true);
            const response = await getDoctorSlots(orgId, doctorId);
            const data = normalizeData(response);
            setDoctorSlots(data || null);
            return data || null;
        } catch (error) {
            console.error("Get appointment details failed:", error);
            return null;
        } finally {
            setMasterLoading(false);
        }
    }, []);

    const fetchDoctorSlotsForDate = useCallback(async (orgId, doctorId, appointmentDate) => {
        try {
            setMasterLoading(true);
            const response = await getDoctorSlotsForDate(orgId, doctorId, appointmentDate);
            const data = normalizeData(response);
            setDoctorSlotsByDate(data || null);
            return data || null;
        } catch (error) {
            console.error("Get appointment details failed:", error);
            return null;
        } finally {
            setMasterLoading(false);
        }
    }, []);

    const fetchDoctorDashboardSummary = useCallback(async (orgId, doctorId) => {
        try {
            setMasterLoading(true);
            const response = await getDashboardSummary(orgId, doctorId);
            const data = normalizeData(response);
            setDoctorDashboardCounts(data || null);
            return data || null;
        } catch (error) {
            console.error("Get appointment details failed:", error);
            return null;
        } finally {
            setMasterLoading(false);
        }
    }, []);

    return {
        units,
        procedures,
        usersByRole,
        appointmentDetails,
        appointmentsByPatientId,
        masterLoading,
        appointmentFiles,
        doctorSlots,
        doctorSlotsByDate,
        doctorDashboardCounts,
        fetchUnits,
        fetchProcedureMasters,
        fetchUsersByRole,
        fetchAppointmentDetailsById,
        fetchAppointmentByPatientId,
        fecthAppointmentfiles,
        fetchDoctorSlots,
        fetchDoctorSlotsForDate,
        fetchDoctorDashboardSummary,
    };
};